import api from "./api";
import types from "./types";
import { request } from "api/apiSaga";
import { snackbarShow } from "app/App/actions";
import trans from "helpers/trans";
import { call, put, takeLatest } from "redux-saga/effects";
import { AnyAction } from "redux";
import { AxiosResponse } from "axios";
import { downloadFromRequest } from "helpers/download";

function* destroy(action: AnyAction): any {
    const response = yield call(request, api.destroy, action, "delete");

    if (response.status === 204) {
        yield put(
            snackbarShow({
                content: trans("event.events.saga.content.destroy"),
            }),
        );
    }
}

function* duplicate(action: AnyAction) {
    const response: AxiosResponse = yield call(
        request,
        api.duplicate,
        action,
        "post",
    );

    if (response.status === 201) {
        yield put(
            snackbarShow({
                content: trans("event.events.saga.content.duplicate"),
            }),
        );
    }
}

function* fetch(action: AnyAction) {
    yield call(request, api.fetch, action);
}

function* fetchAll(action: AnyAction) {
    yield call(request, api.fetchAll, action);
}

function* fetchTickets(action: AnyAction) {
    yield call(request, api.fetchTickets, action);
}

function* fetchTicketsStats(action: AnyAction) {
    yield call(request, api.fetchTicketsStats, action);
}

function* get(action: AnyAction) {
    yield call(request, api.get, action);
}

function* store(action: AnyAction): any {
    const response = yield call(request, api.store, action, "post");

    if (response.status === 201) {
        yield put(
            snackbarShow({
                content: trans("event.events.saga.content.store"),
            }),
        );
    }
}

function* update(action: AnyAction): any {
    const response = yield call(request, api.update, action, "put");

    if (response.status === 200) {
        yield put(
            snackbarShow({
                content: trans("event.events.saga.content.update"),
            }),
        );
    }
}

function* exportTickets(action: AnyAction): any {
    const response = yield call(request, api.exportTickets, action);
    if (response.status === 200) {
        downloadFromRequest(response);
        yield put(
            snackbarShow({
                content: trans("event.events.saga.content.export"),
            }),
        );
    }
}

function* exportTicketsPdf(action: AnyAction): any {
    const response = yield call(request, api.exportTicketsPdf, action);
    if (response.status === 200) {
        downloadFromRequest(response);
        yield put(
            snackbarShow({
                content: trans("event.events.saga.content.export"),
            }),
        );
    }
}

export default function* saga() {
    yield takeLatest(types.DESTROY_REQUEST, destroy);
    yield takeLatest(types.DUPLICATE_REQUEST, duplicate);
    yield takeLatest(types.FETCH_REQUEST, fetch);
    yield takeLatest(types.FETCH_TICKETS_REQUEST, fetchTickets);
    yield takeLatest(types.FETCH_TICKETS_STATS_REQUEST, fetchTicketsStats);
    yield takeLatest(types.FETCH_ALL_REQUEST, fetchAll);
    yield takeLatest(types.GET_REQUEST, get);
    yield takeLatest(types.STORE_REQUEST, store);
    yield takeLatest(types.UPDATE_REQUEST, update);
    yield takeLatest(types.EXPORT_TICKETS_REQUEST, exportTickets);
    yield takeLatest(types.EXPORT_TICKETS_PDF_REQUEST, exportTicketsPdf);
}
